import React from 'react';

const IcAccountFillOn = () => {
    return (
        <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M18.0724 1.6476C16.2911 0.600488 14.2157 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 10.227 23.6155 8.54391 22.9254 7.0294C22.6739 7.07575 22.4147 7.09998 22.1499 7.09998C19.8027 7.09998 17.8999 5.19719 17.8999 2.84998C17.8999 2.43238 17.9601 2.02885 18.0724 1.6476Z'
                fill='#DBDCDF'
            />
            <path
                d='M11.9999 11C13.9881 11 15.5999 9.38827 15.5999 7.40005C15.5999 5.41182 13.9881 3.80005 11.9999 3.80005C10.0117 3.80005 8.3999 5.41182 8.3999 7.40005C8.3999 9.38827 10.0117 11 11.9999 11Z'
                fill='white'
            />
            <path
                d='M12.0084 22.0001C15.0305 22.0001 17.7396 20.6594 19.5732 18.5404C19.7009 18.3928 19.7435 18.1894 19.6814 18.0044C18.6719 14.9987 15.4396 12.8 11.6083 12.8C8.0954 12.8 5.08619 14.6483 3.83206 17.2722C3.74508 17.4542 3.76657 17.6686 3.88433 17.8323C5.69956 20.3564 8.66201 22.0001 12.0084 22.0001Z'
                fill='white'
            />
            <path d='M25 2.85C25 4.42401 23.7241 5.7 22.15 5.7C20.576 5.7 19.3 4.42401 19.3 2.85C19.3 1.27599 20.576 0 22.15 0C23.7241 0 25 1.27599 25 2.85Z' fill='#406CC5' />
        </svg>
    );
};

export default IcAccountFillOn;
